import ControlButtonLabel from 'components/atoms/control-panel-dropdown-label';
import SmsIcon from 'components/atoms/icons/smsIcon';
import { ModuleType } from 'infrastructure/enums';
import { useTranslation } from 'react-i18next';
import { makeid } from 'utils/helpers/makeid';
import { isPractice } from 'utils/userTypeHelper';

const getModule = (isRpm?: boolean) => {
  if (typeof isRpm === 'boolean' && isRpm) return ModuleType.RPM;
  if (typeof isRpm === 'boolean' && !isRpm) return ModuleType.CCM;
  return null;
};

interface Props {
  doctorWorkNumber?: string;
  isAdminPanel: boolean;
  patientHasSecondaryNumber: boolean;
  userType: string;
  setSmsPopupOpen: (arg: boolean) => void;
  setIsPrimaryNumber: (arg: boolean) => void;
  setDoctorSmsPopupOpen?: (arg: boolean) => void;
  setCurrentModule?: (module: ModuleType | null) => void;
}

export const useSmsButtons = ({
  doctorWorkNumber,
  isAdminPanel,
  patientHasSecondaryNumber,
  userType,
  setSmsPopupOpen,
  setIsPrimaryNumber,
  setDoctorSmsPopupOpen,
  setCurrentModule,
}: Props) => {
  const { t } = useTranslation();

  const smsButtons = [
    {
      id: makeid(5),
      render: true,
      label: (
        <ControlButtonLabel
          title={t('labels.smsPrimary')}
          subtitle={t('labels.phoneNumber')}
        />
      ),
      handleClick: (isRpm?: boolean) => {
        setSmsPopupOpen(true);
        setIsPrimaryNumber(true);
        const module = getModule(isRpm);
        setCurrentModule?.(module);
      },
    },
    {
      id: makeid(5),
      render: !!patientHasSecondaryNumber,
      label: (
        <ControlButtonLabel
          title={t('labels.smsSecondary')}
          subtitle={t('labels.phoneNumber')}
        />
      ),
      handleClick: (isRpm?: boolean) => {
        setSmsPopupOpen(true);
        setIsPrimaryNumber(false);
        const module = getModule(isRpm);
        setCurrentModule?.(module);
      },
    },
    {
      id: makeid(5),
      render: doctorWorkNumber && !isPractice(userType) && !isAdminPanel,
      label: (
        <ControlButtonLabel
          title={t('labels.smsPrimary')}
          subtitle={t('labels.doctor')}
        />
      ),
      icon: SmsIcon,
      handleClick: () => {
        setDoctorSmsPopupOpen?.(true);
      },
    },
  ].filter(({ render }) => render);

  return smsButtons;
};
